export type QueryValue = string | null | undefined

type QueryParams = Record<string, QueryValue>

/**
 * Appends defined query params to a route path.
 * Null and undefined values are omitted so callers can pass optional fields directly.
 */
export function withQuery(path: string, query?: QueryParams): string {
    if (!query) return path

    const params = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            params.set(key, value)
        }
    })

    const queryString = params.toString()
    return queryString ? `${path}?${queryString}` : path
}
